export const AUTH = '[Auth]'

export const INIT_REQUEST = `${AUTH} INIT_REQUEST`
export const LOGIN_REQUEST = `${AUTH} LOGIN_REQUEST`
export const FETCH_AUTHENTICATED_USER_SUCCESS = `${AUTH} FETCH_AUTHENTICATED_USER_SUCCESS`
export const LOGOUT_REQUEST = `${AUTH} LOGOUT_REQUEST`
export const LOGOUT_SUCCESS = `${AUTH} LOGOUT_SUCCESS`
export const SESSION_EXPIRED = `${AUTH} SESSION_EXPIRED`
export const SET_LOGIN_ERROR = `${AUTH} SET_LOGIN_ERROR`
export const SET_SIDEBAR_STATE = `${AUTH} SET_SIDEBAR_STATE`
export const SET_TOKEN = `${AUTH} SET_TOKEN`

export const FETCH_AUTHENTICATED_USER_REQUEST = `${AUTH} FETCH_AUTHENTICATED_USER_REQUEST`
